import React, { useEffect, useState, useCallback } from "react";
import { Box, Typography, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate, useParams } from "react-router-dom";
import { useIntl } from "react-intl";
import { fetchDataTypes } from "../../api/companyApi";
import { useNotification } from "../../providers/NotificationProvider";

const DATA_CLASS_LABELS = {
  MasterData: "dataType.class.MasterData",
  TransactionData: "dataType.class.TransactionData",
  AccountData: "dataType.class.AccountData",
  ReferenceData: "dataType.class.ReferenceData",
  ManagementData: "dataType.class.ManagementData",
  Document: "dataType.class.Document",
  Image: "dataType.class.Image",
  Video: "dataType.class.Video",
  Audio: "dataType.class.Audio",
  None: "dataType.class.None",
};

export default function DataTypeListPage() {
  const { businessDomainId } = useParams();
  const navigate = useNavigate();
  const intl = useIntl();
  const notify = useNotification();
  const t = (id) => intl.formatMessage({ id });

  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadData = useCallback(async () => {
    setLoading(true);
    try { setRows(await fetchDataTypes(businessDomainId)); }
    catch (e) { notify.apiError(e); }
    finally { setLoading(false); }
  }, [businessDomainId]);

  useEffect(() => { loadData(); }, [loadData]);

  const handleRowClick = (params) => {
    navigate(`/design/${businessDomainId}/data-types/${params.row.dataTypeId}`);
  };

  const columns = [
    { field: "dataTypeName", headerName: t("dataType.name"), flex: 1, minWidth: 200 },
    {
      field: "dataClass", headerName: t("dataType.dataClass"), width: 160,
      renderCell: (p) => {
        const key = DATA_CLASS_LABELS[p.value];
        return key ? t(key) : (p.value || "");
      },
    },
  ];

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
        <Typography variant="h6">{t("dataType.list.title")}</Typography>
        <Button variant="contained" startIcon={<AddIcon />} onClick={() => navigate(`/design/${businessDomainId}/data-types/create`)}>
          {t("common.add")}
        </Button>
      </Box>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(r) => r.dataTypeId}
        loading={loading}
        autoHeight
        pageSizeOptions={[10, 25, 50]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        disableRowSelectionOnClick
        onRowClick={handleRowClick}
        sx={{ "& .MuiDataGrid-row": { cursor: "pointer" } }}
      />
    </Box>
  );
}
